import { get, optic, set } from "optics-ts";
import type { Lens, OpticFor, OpticParams } from "optics-ts";
import { useAtom } from "jotai";
import type { WritableAtom } from "jotai";

export function isNotNull<T>(x: T): x is NonNullable<T> {
  return x != null;
}

export function opt<T, S>(x: T, fn: (x: NonNullable<T>) => S): S | null {
  if (isNotNull(x)) {
    return fn(x);
  } else {
    return null;
  }
}
export function useFocusAtom<F, T extends OpticParams, A>(
  atom: WritableAtom<F, F>,
  fn: (o: OpticFor<F>) => Lens<F, T, A>
) {
  const [value, setValue] = useAtom(atom);
  let g = fn(optic<F>());

  return [get(g)(value), (x: A) => setValue(set(g)(x)(value))] as const;
}
